module.exports = __webpack_public_path__ + "waxjet-510-3.png?28f2e9485c06316645bad77273af33fb";